import { Container } from "react-bootstrap";
import logo from "../assets/img/pfp-img.png";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';

export const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <div className="footer-inner">
                    <div className="footer-brand">
                        <img src={logo} alt="Ayomikun" />
                        <div className="footer-brand-name">
                            <strong>Ayomikun</strong>
                            <span>Web Dev &amp; Digital Marketer</span>
                        </div>
                    </div>

                    <div className="footer-right">
                        <div className="social-icon">
                            <a href="https://github.com/Ayomikun2820" target="_blank" rel="noreferrer">
                                <img src={navIcon1} alt="GitHub" />
                            </a>
                            <a href="https://x.com/_Ayomikun" target="_blank" rel="noreferrer">
                                <img src={navIcon2} alt="X / Twitter" />
                            </a>
                            <a href="https://www.instagram.com/mikun.dev/" target="_blank" rel="noreferrer">
                                <img src={navIcon3} alt="Instagram" />
                            </a>
                        </div>
                        <p>Copyright &copy; {new Date().getFullYear()} Media Cartel. All Rights Reserved</p>
                    </div>
                </div>
            </Container>
        </footer>
    );
};
